module.exports = __webpack_public_path__ + "static/media/aijiaGrammer4.22c76cd0.jpg";